import { ExternalLink, Link2 } from "lucide-react";

import { Button } from "@/components/button";
import { convertUTCtoEastern } from "@/utils/timezoneConverter.ts";

type DisplayLinkProps = {
  createdAt?: null | string;
  url: string;
};

export function DisplayOnlyLink({ createdAt, url }: DisplayLinkProps) {
  return (
    <div className="flex items-center justify-between gap-xs rounded-xl border border-border-secondary bg-bg-primary px-xl py-md">
      <div className="flex items-center gap-md overflow-hidden">
        <ExternalLink className="shrink-0 text-fg-quinary" size={16} />
        <div className="flex flex-col overflow-hidden">
          <a
            className="text-sm font-medium text-utility-blue-700 hover:underline break-all"
            href={url}
            rel="noreferrer"
            target="_blank"
            title={url}
          >
            {url}
          </a>
          {createdAt && (
            <span className="text-xs text-text-tertiary">
              Added {convertUTCtoEastern(createdAt, "MMM D, YYYY")}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-xs">
        <Button asChild color="gray" isIconOnly size="sm" variant="tertiary">
          <a href={url} rel="noreferrer" target="_blank">
            <Link2 className="text-button-tertiary-color-fg" />
          </a>
        </Button>
      </div>
    </div>
  );
}
